import { Injectable, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { TellentAdminHttpApiErrorHandlerService } from '@core/tellent-http-legacy';
import { TellentComponentsNotificationService } from '@core/tellent-util';

@Injectable({ providedIn: 'root' })
export class TellentClientGlobalNotificationsService {
  private tellentAdminHttpApiErrorHandlerService = inject(TellentAdminHttpApiErrorHandlerService);
  private i18nService = inject(I18nService);
  private notificationsController = inject(TellentComponentsNotificationService);

  constructor() {
    this.watchInternalServerError();
  }

  private watchInternalServerError(): void {
    this.tellentAdminHttpApiErrorHandlerService.internalServerError$.subscribe(() => {
      const title = this.i18nService.translate('tlc.common.errors.server_error.title');
      const message = this.i18nService.translate('tlc.common.errors.server_error.message');
      this.notificationsController.error(title, message);
    });
  }
}
